module.exports = __webpack_public_path__ + "static/media/icon_nav_patient.bf0b35d7.svg";